import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";
import { startRegisterSearchResult } from "./searchResultActions";
import { dispatchSearchFilterResults } from "../helpers/searchFilterDispatch.helper";
import { resolveFlowListQueryFromState } from "../helpers/flowModuleListQueryHelper";

/*Reorganizados*/

/* Metodos Principales */
export const regulationStartRegisterAdmin = (regulation, navigate, returnTo) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_REGULATION}`,
      "add",
      regulation,
      "POST"
    );

    const body = await resp.json();

    debugLogActions(':: regulationActions, regulationStartRegisterAdmin', { 'body': body });

    if (body.ok) {

      const regulationSaved = body.regulation;

      dispatch(regulationRegisterAdmin(regulationSaved));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            const nextPath = typeof returnTo === "string" && returnTo.startsWith("/")
              ? returnTo
              : "/specialist-regulation";
            navigate(nextPath);
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const regulationRegisterAdmin = (regulation) => ({
  type: types.REGULATION_START_REGISTER_ADMIN,
  payload: regulation,
});

export const regulationStartUpdate = (regulation, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_REGULATION}`,
        `update/${regulation.id}`,
        regulation,
        "PUT"
      );
      const body = await resp.json();

      debugLogActions(':: regulationActions, regulationStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(regulationUpdated(regulation));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        });

      } else {

        if (body.errors) {
          const { catalogserie_id } = body.errors;

          if (catalogserie_id) {
            Swal.fire(t("titles.error"), catalogserie_id.msg, "error");
            
          }
        }

        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: regulationActions, regulationStartUpdate', { 'error': error });
    }
  };
};

const regulationUpdated = (regulation) => {
  return {
    type: types.REGULATION_UPDATE,
    payload: regulation,
  };
};

export const regulationStartDelete = (id, onDeleted) => {
  return async (dispatch, getState) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_REGULATION}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {

              debugLogActions(':: regulationActions, regulationStartDelete', { 'body': body });

              if (body.ok) {
                dispatch(regulationDeleted(id));
                if (typeof onDeleted === "function") {
                  onDeleted();
                }
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: regulationActions, regulationStartDelete', { 'error': error });
    }
  };
};

const regulationDeleted = (id) => {
  return {
    type: types.REGULATION_DELETE,
    payload: id,
  };
};

export const startLoadingRegulationsPaginated = (page, size) => {
  return async (dispatch, getState) => {
    const query = resolveFlowListQueryFromState(getState, 'regulation');
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_REGULATION}`, `get/${page}/${size}${query}`);
    const body = await resp.json();

    debugLogActions(':: regulationActions, startLoadingRegulationsPaginated', { 'body': body });

    if (body.ok) {
      dispatch(loadingRegulationsPaginated(body.regulationsPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingRegulationsPaginated = (regulationsPaginated) => ({
  type: types.REGULATION_START_LOADING_PAGINATED,
  payload: regulationsPaginated,
});

export const startLoadingRegulationsByTextRegulationPaginated = (regulation, page, size, catalogToFilter, indicatorToFilter = [], codeCiiuLevel1={}) => {
  return async (dispatch, getState) => {

    const searchInfo = {
      searchRegulationText: regulation,
      codeCiiuLevel1: codeCiiuLevel1,
      catalogToFilter: catalogToFilter,
      indicatorToFilter: indicatorToFilter,
    };

    dispatch(regulationIsLoading());

    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_REGULATION}`,
      `getByTextRegulation/${page}/${size}`,
      searchInfo,
      "POST"
    );
    const body = await resp.json();

    debugLogActions(':: regulationActions, startLoadingRegulationsByTextRegulationPaginated', { 'body': body });

    if (body.ok) {

      dispatch(regulationIsLoadingFinish());

      // filterResults puede ser null en path semántico vacío
      dispatchSearchFilterResults(dispatch, body.filterResults);

      body.regulationsPaginated.regulationsP.forEach(element => {
        element.isSelected = false;
        element.isCompared = false;
      });

      dispatch(loadingRegulationsByTextRegulationPaginated(body.regulationsPaginated));

      const { totalItems, totalPages, currentPage, regulationsP } = body.regulationsPaginated;
      
            let index = 0;
            let registerIds = "";
            regulationsP.forEach(element => {
      
              if (index === 0) {
                registerIds = registerIds.concat(element.id);
              } else {
                registerIds = registerIds.concat(";", element.id);
              }
      
              index = index + 1;
            });
      
            const state = getState();
            const { searchInfo } = state.searchInfo;
      
            const searchResult = {
              filter_results: body.filterResults,
              total_items: totalItems,
              total_pages: totalPages,
              current_page: currentPage,
              search_results_ids: registerIds,
              deleted: false,
              searchinfo_id: searchInfo.id
            }
      
            dispatch(startRegisterSearchResult(searchResult));

    } else {

      dispatch(regulationIsLoadingFinish());
      
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const loadingRegulationsByTextRegulationPaginated = (regulationsPaginated) => ({
  type: types.REGULATION_START_LOADING_REGULATION_PAGINATED,
  payload: regulationsPaginated,
});

export const startSearchingRegulationsPaginated = (textSearch, page, size) => {
  
  return async (dispatch, getState) => {
    const query = resolveFlowListQueryFromState(getState, 'regulation');
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_REGULATION}`,
      `search/${textSearch}/${page}/${size}${query}`
    );
    const body = await resp.json();

    debugLogActions(':: regulationActions, startSearchingRegulationsPaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingRegulationsPaginated(body.regulationsPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const searchingRegulationsPaginated = (regulationsPaginated) => ({
  type: types.REGULATION_START_SEARCH_PAGINATED,
  payload: regulationsPaginated,
});

export const selectRegulation = (regulation) => ({
  type: types.REGULATION_SELECT,
  payload: regulation,
});

export const cleanRegulationsPaginatedS = () => ({
  type: types.REGULATION_CLEAN_SEARCH_PAGINATED,
});

export const cleanRegulationsPaginatedP = () => ({
  type: types.REGULATION_CLEAN_PAGINATED,
});

export const regulationSetSearchText = (searchText) => ({
  type: types.REGULATION_SET_SEARCH_TEXT,
  payload: searchText,
});

export const regulationCleanSearchText = () => ({
  type: types.REGULATION_CLEAN_SEARCH_TEXT,
});

export const regulationCleanSaved = () => ({
  type: types.REGULATION_CLEAN_SAVED,
});

//Si van 13 de Feb 2026
export const regulationListUpdateSelected = (id) => ({
  type: types.REGULATION_LIST_UPDATE_SELECTED,
  payload: id
});

export const regulationListSelectAllLimit = () => ({
  type: types.REGULATION_SELECT_ALL_LIMIT,
});

export const regulationCleanAllSelected = () => ({
  type: types.REGULATION_CLEAN_ALL_SELECTED,
});

export const regulationIsLoading = () => ({
  type: types.REGULATION_IS_LOADING
});

export const regulationIsLoadingFinish = () => ({
  type: types.REGULATION_IS_LOADING_FINISH
});

//No van 13 de Feb 2026

export const regulationGetMoreThanOneIsSelected = () => ({
  type: types.REGULATION_GET_MORE_THAN_ONE_SELECTED
});

export const regulationGetNumberRegulationSelected = (countCompareFlag) => ({
  type: types.REGULATION_LIST_SET_NUMBER_SELECTED,
  payload: countCompareFlag
});

export const cleanSearchInformation = () => ({
  type: types.REGULATION_CLEAN_SEARCH_INFORMATION,
});